import {
  fetchNotification,
  toggleNotification,
} from "@/api/notificationService";

export default {
  //Fetch notification
  async fetchNotification({ commit }) {
    // eslint-disable-next-line no-useless-catch
    try {
      const response = await fetchNotification();
      const notifications = response.data.data;
      commit("SET_NOTIFICATION_DATA", notifications);
      commit("HIDE_PROGRESSBAR", false, { root: true });
    } catch (error) {
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.message || "Something went wrong",
          color: "error",
        },
        { root: true }
      );
    }
  },

  //Toggle status
  async toggleNotification({ commit, dispatch }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      await toggleNotification(payload);
      dispatch("fetchNotification");
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Notification updated!",
          color: "success",
        },
        { root: true }
      );
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.message,
          color: "error",
        },
        { root: true }
      );
    }
  },
};
